import { initializeApp } from 'firebase/app';
import { RemoteConfig } from 'firebase/remote-config';
import {
  FEATURE_FLAGS,
  initFirebaseRemoteConfig,
} from '@leagueplatform/highmark-common';

// Firebase config constants
const firebaseConfig = {
  apiKey: 'AIzaSyDGwlomjtFb40kFNqnW3bWcqzHU9WTHi7o',
  authDomain: 'league-hm-firebase-allmyhealth.firebaseapp.com',
  projectId: 'league-hm-firebase-allmyhealth',
  storageBucket: 'league-hm-firebase-allmyhealth.appspot.com',
  messagingSenderId: '241294430896',
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

// In-app default values for feature flags - fallback values in case of network errors
export const FIREBASE_DEFAULT_VALUES = {
  [FEATURE_FLAGS.PLACEHOLDER_FLAG]: false, // placeholder flag (do not remove)
  /* Add default values for active flags below this line */
  [FEATURE_FLAGS.CLAIMS_SHOULD_SHOW_CLAIM_DETAILS]: false,
  [FEATURE_FLAGS.USER_DROPDOWN_COBROWSE]: false,
};

export const firebaseRemoteConfig: RemoteConfig = initFirebaseRemoteConfig({
  firebaseApp,
  defaultValues: FIREBASE_DEFAULT_VALUES,
  // *NOTE: Uncomment the following line for development/debugging
  // minimumFetchIntervalMillis: 60 * 1000, // 1 min
});
